import BaseService from '_services/rest/base';

class RepresentativeService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/representative`;
  }

  getUrlSave(id, url = '/') {
    if (id) {
      return {
        url: `${this.getUrl()}/${url}${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getRepresentativeById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteRepresentative(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(representative) {
    const meta = this.getUrlSave(representative.id, '');
    return this.request(meta.url, representative, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getAttachedResellers(params) {
    const data = { group: params.group, search: params.search, state: params.state };
    return this.request(`${this.getUrl()}/${params.representativeId}/reseller`, data)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  syncResellers(resellers, id) {
    return this.request(`${this.getUrl()}/${id}/reseller`, resellers, 'PUT')
      .catch(err => {
        throw err;
      });
  }
}

export default new RepresentativeService();
